import { TransactionTimerDropOffPendingDurationMetricChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { Last60DaysPudoTimerDurationMetricChartCard } from '../last-60-days-pudo-timer-duration-metric-chart-card.component';

export interface Last60DaysPudoTransactionDropOffTimeMetricChartProps {
    accountId: string;
}

export const Last60DaysPudoTransactionDropOffTimeMetricChart = ({ accountId }: Last60DaysPudoTransactionDropOffTimeMetricChartProps) => (
    <Last60DaysPudoTimerDurationMetricChartCard
        accountId={accountId}
        title={
            <FormattedMessage
                id='platform.statistics.pudo.last-60-days-pudo-transaction-drop-off-time-metric-chart.title'
                description='Title of the PuDo dashboard card showing average drop-off time compared to last month'
                defaultMessage='Drop-off time'
            />
        }
        Chart={TransactionTimerDropOffPendingDurationMetricChart}
    />
);
